var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownWhiteOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2508 11.4901L15.4333 6.30638C15.5506 6.18902 15.7098 6.12309 15.8758 6.12309C16.0418 6.12309 16.2009 6.18902 16.3183 6.30638C16.4356 6.42374 16.5016 6.58291 16.5016 6.74888C16.5016 6.91485 16.4356 7.07402 16.3183 7.19138L10.6933 12.8164C10.6352 12.8746 10.5663 12.9208 10.4903 12.9523C10.4144 12.9838 10.333 13 10.2508 13C10.1686 13 10.0872 12.9838 10.0112 12.9523C9.93532 12.9208 9.86635 12.8746 9.80829 12.8164L4.18329 7.19138C4.06593 7.07402 4 6.91485 4 6.74888C4 6.58291 4.06593 6.42374 4.18329 6.30638C4.30065 6.18902 4.45982 6.12309 4.62579 6.12309C4.79176 6.12309 4.95093 6.18902 5.06829 6.30638L10.2508 11.4901Z",
    fill: "#F0F0F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownWhiteOpen);
export default __webpack_public_path__ + "static/media/DropdownWhiteOpen.130fcdbb6ad968419ea8229c3478e44e.svg";
export { ForwardRef as ReactComponent };